import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  constructor() { }

  private readonly ONBOARDING_KEY = 'onboarding_completed';

  isOnboardingCompleted(): boolean {
    return localStorage.getItem(this.ONBOARDING_KEY) === 'true';
  }

  setOnboardingCompleted(): void {
    localStorage.setItem(this.ONBOARDING_KEY, 'true');
  }
}
